var map = {
	"./arduino-placa.svg": "eBfC",
	"./arduino.svg": "xVHO",
	"./beco.svg": "0eJM",
	"./catArduino.svg": "l8Uf",
	"./catComponentes.svg": "M209",
	"./catPrototipagem.svg": "uEQE",
	"./catRobotica.svg": "WfTz",
	"./felipe.svg": "H+X9",
	"./led-light.svg": "+1UL",
	"./logo-beco-svg.svg": "g6EU",
	"./luan.svg": "ygJR",
	"./multimeter.svg": "1AEj",
	"./part1.svg": "P41k",
	"./part2.svg": "lBGb",
	"./part3.svg": "UXaE",
	"./product.svg": "IV2R",
	"./question.svg": "PfSF",
	"./robocop.svg": "3QzV",
	"./target.svg": "c3H6",
	"./toin.svg": "SbHO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "707r";


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.svg$
// module id = 707r
// module chunks = 0